import { FormikConfig } from "formik";
import type { JSX } from "react";
import PrimaryInfoForm from "./PrimaryInfoForm";
import { FormValues } from "./support";

interface ProfileMultiFormProps {
  profile: FormValues;
  handleProfileUpdate: (values: FormValues) => Promise<void>;
  ready: boolean;
}

const ProfileMultiForm = ({
  profile,
  handleProfileUpdate,
  ready,
}: ProfileMultiFormProps): JSX.Element => {
  const submitForm: FormikConfig<FormValues>["onSubmit"] = async (
    values,
    { setSubmitting },
  ): Promise<void> => {
    setSubmitting(true);
    try {
      await handleProfileUpdate(values);
    } catch (e) {
      console.error(e);
    }
    setSubmitting(false);
  };

  const formProps = { onSubmit: submitForm, ready, profile };
  return (
    <>
      <PrimaryInfoForm {...formProps} />
      {/**
        TODO: Re-enable once there is more stability around demographics questions values in AK
        Ticket: https://github.com/dsausa-internal/mydsa/issues/25
        ---
        <Divider sx={{ my: 6 }} />
        <DemographicsForm {...formProps} />
      */}
    </>
  );
};

export default ProfileMultiForm;
